import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";

import { CustomEncoder } from "@/shared-module/helpers/customencoder";

@Injectable({ providedIn: "root" })
export class ZoomService {
  constructor(private http: HttpClient) {}

  get(prms: any = null, selectedPeriod: number = null) {
    // without these lines, the + character is not encoded in the url,
    // see : https://github.com/angular/angular/issues/18884
    let params = new HttpParams({
      fromObject: prms,
      encoder: new CustomEncoder(),
    });

    if (selectedPeriod) {
      params = params.set("periodId", selectedPeriod.toString());
    }

    return this.http.get<string>(`api/zoom`, { params }).pipe((s) => {
      return s;
    });
  }

  getTexts() {
    return this.http.get<string>(`api/texts`).pipe((s) => {
      return s;
    });
  }
}
